module.exports = "<div class=\"page-logo-container\">\n  <img src=\"assets/img/Logo.jpg\" alt=\"CSI Logo\" />\n</div>"